import React, { Component } from 'react';
import { Flex, Box } from 'reflexbox';
import Button from 'components/Button';
import Text from 'components/Text';

import ClickCollect from './components/ClickCollect';
import ClickCollectSubmit from './components/ClickCollectSubmit';
import ClickDeliver from './components/ClickDeliver';

import PropTypes from 'prop-types';

import './collectionOptions.styles.scss';

import imgDeliveryCCBlack from 'images/ws-click-and-collect.svg';
import imgDeliveryCCBlue from 'images/ws-click-and-collect-blue.svg';
import imgDeliveryHomeBlack from 'images/ws-home-delivery.svg';
import imgDeliveryHomeBlue from 'images/ws-home-delivery-blue.svg';

export default class CollectionOptions extends Component {
    constructor(props) {
        super(props);

        let visibleOption = '';
        if (window.Checkout.settings.clickcollect.enable_on_shoppinglist && !window.Checkout.settings.clickdeliver.enable_on_shoppinglist) {
            visibleOption = 'collect';
        }
        if (!window.Checkout.settings.clickcollect.enable_on_shoppinglist && window.Checkout.settings.clickdeliver.enable_on_shoppinglist) {
            visibleOption = 'deliver';
        }

        this.state = { visibleOption };
    }

    onClick(visibleOption) {
        this.setState({ visibleOption });
    }

    render() {
        const { shoppingListView, products } = this.props;

        const noProductsAvailable = Object.keys(products).length === 0;

        if (noProductsAvailable || (!window.Checkout.settings.clickcollect.enable_on_shoppinglist && !window.Checkout.settings.clickdeliver.enable_on_shoppinglist)) {
            return null;
        }

        return (
            <Box className="collectionoptions" p={2} pt={40} mt={3} mx={-2}>
                { window.Checkout.settings.clickcollect.enable_on_shoppinglist && window.Checkout.settings.clickdeliver.enable_on_shoppinglist &&
                    <Box mt={2}>
                        <Box w={1} pt={2} className="collectionoptions_header">
                            <h2><Text textKey="delivery_options_headline" /></h2>
                        </Box>
                        <Flex className="collectionoptions__options" my={2}>
                            <Box w={1} className={`collectionoptions__option ${this.state.visibleOption === 'deliver' ? 'collectionoptions__option--active' : ''}`}>
                                <Button
                                    theme="unstyled"
                                    text="collectionoptions_deliver"
                                    onClick={this.onClick.bind(this, 'deliver')}
                                    icon={this.state.visibleOption === 'deliver' ? imgDeliveryHomeBlue : imgDeliveryHomeBlack}
                                />
                            </Box>
                            <Box w={1} className={`collectionoptions__option ${this.state.visibleOption === 'collect' ? 'collectionoptions__option--active' : ''}`}>
                                <Button
                                    theme="unstyled"
                                    text="collectionoptions_collect"
                                    onClick={this.onClick.bind(this, 'collect')}
                                    icon={this.state.visibleOption === 'collect' ? imgDeliveryCCBlue : imgDeliveryCCBlack}
                                />
                            </Box>
                        </Flex>
                    </Box>
                }
                { window.Checkout.settings.clickcollect.enable_on_shoppinglist && this.state.visibleOption === 'collect' &&
                    <>
                        { !window.Checkout.settings.clickdeliver.enable_on_shoppinglist &&
                            <Box className="collectionoptions_header">
                                {shoppingListView === 'buyonline' &&
                                    <h2><Text textKey="collectionoptions_headline_buyonline" /></h2>
                                }
                                {shoppingListView === 'availableinstore' &&
                                    <h2><Text textKey="collectionoptions_headline_availableinstore" /></h2>
                                }
                                <Box mb={3}>
                                    <ol className="collectionoptions_header__timeline">
                                        <li className="event">
                                            <span><Text textKey="collectionoptions_step_1" /></span>
                                        </li>
                                        <li className="event">
                                            <span><Text textKey="collectionoptions_step_2" /></span>
                                        </li>
                                        <li className="event">
                                            <span><Text textKey="collectionoptions_step_3" /></span>
                                        </li>
                                    </ol>
                                </Box>
                            </Box>
                        }
                        <ClickCollect/>
                        <ClickCollectSubmit/>
                    </>
                }
                { window.Checkout.settings.clickdeliver.enable_on_shoppinglist && this.state.visibleOption === 'deliver' &&
                    <ClickDeliver/>
                }
            </Box>
        );
    }
}

CollectionOptions.propTypes = {
    shoppingListView: PropTypes.string,
    products: PropTypes.object.isRequired,
};
